module.exports = __webpack_public_path__ + "static/media/ex16.b0cc43dd.mp3";